import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, themeMode } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
var Handle = styled(Box).withConfig({
  componentId: "sc-16zfyo6-0"
})(["background-color:", ";position:absolute;cursor:", ";", ";", ";"], function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? palette("neutral.400") : palette("primary.500");
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled ? "auto" : "pointer";
}, function (_ref3) {
  var radius = _ref3.radius;
  return "\n        width: " + radius * 2 + "px;\n        height: " + radius * 2 + "px;\n        border-radius: " + radius * 2 + "px;\n        top: " + -radius + "px;\n        left: " + -radius + "px;\n    ";
}, function (_ref4) {
  var isDisabled = _ref4.isDisabled;
  return isDisabled && "pointer-events: none;";
});
var Draggable = styled.div.withConfig({
  componentId: "sc-16zfyo6-1"
})(["transform:", ";position:absolute;"], function (_ref5) {
  var position = _ref5.position,
      radius = _ref5.radius;
  return "translateX(" + (position - radius / 2) + "px)";
});
var Rail = styled(Box).withConfig({
  componentId: "sc-16zfyo6-2"
})(["width:100%;height:2px;background-color:", ";"], function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled ? palette("neutral.400") : themeMode({
    light: palette("neutral.300"),
    dark: palette("neutral.600")
  });
});
var ActiveRangeRail = styled(Box).withConfig({
  componentId: "sc-16zfyo6-3"
})(["position:absolute;width:", ";height:2px;background-color:", ";transform:", ";"], function (_ref7) {
  var range = _ref7.range;
  return range.max - range.min + "px";
}, function (_ref8) {
  var isDisabled = _ref8.isDisabled;
  return isDisabled ? palette("neutral.400") : palette("primary.500");
}, function (_ref9) {
  var range = _ref9.range,
      handleRadius = _ref9.handleRadius;
  return "translateX(" + (range.min - handleRadius) + "px)";
});
var Slider = styled(Box).withConfig({
  componentId: "sc-16zfyo6-4"
})(["display:flex;flex-direction:column;"]);
export { ActiveRangeRail, Draggable, Handle, Rail, Slider };